import { Flex } from "@radix-ui/themes";
import { LuFilter } from "react-icons/lu";
import {
  MarketplaceSearch,
  MarketplaceFilterKey,
  MarketplaceSort,
  MarketplaceUpdates,
} from "./types";
import { SORT_OPTIONS } from "@/lib/marketplace-sort";
import GenreFilter from "./FilterSection/GenreFilter";
import BPMFilter from "./FilterSection/BPMFilter";
import KeyFilter from "./FilterSection/KeyFilter";
import MoodsFilter from "./FilterSection/MoodsFilter";
import SortDropdown from "./SortDropdown";

type TopFiltersControlsProps = {
  searchParameters: MarketplaceSearch;
  onSetFilter: (updates: MarketplaceUpdates) => void;
  onRemoveFilter: (param: MarketplaceFilterKey) => void;
  showFilters?: boolean;
  sortOptions?: { value: MarketplaceSort; label: string }[];
};

export default function TopFiltersControls({
  searchParameters,
  onSetFilter,
  onRemoveFilter,
  showFilters = true,
  sortOptions = SORT_OPTIONS,
}: TopFiltersControlsProps) {
  const hasTopFilters = Boolean(
    searchParameters.genre ||
      searchParameters.mood ||
      searchParameters.key ||
      searchParameters.bpm,
  );

  return (
    <Flex
      direction="row"
      align="center"
      gap="2"
      wrap="nowrap"
      mb={hasTopFilters ? "8px" : "0"}
      pb="8px"
      className="border-b-[1px] border-[#050C2B14]"
    >
      {showFilters && (
        <>
          <LuFilter
            className="shrink-0 text-[16px] text-[#525966]"
            aria-hidden
          />
          <GenreFilter
            parameter={searchParameters.genre}
            onSetFilter={onSetFilter}
            onRemoveFilter={onRemoveFilter}
          />

          <MoodsFilter
            parameter={searchParameters.mood}
            onSetFilter={onSetFilter}
            onRemoveFilter={onRemoveFilter}
          />

          <KeyFilter
            parameter={searchParameters.key}
            onSetFilter={onSetFilter}
            onRemoveFilter={onRemoveFilter}
          />

          <BPMFilter
            parameter={searchParameters.bpm}
            onSetFilter={onSetFilter}
            onRemoveFilter={onRemoveFilter}
          />
        </>
      )}

      <Flex className="ml-auto">
        <SortDropdown
          value={searchParameters.sort as MarketplaceSort | undefined}
          onChange={(value) => onSetFilter({ sort: value })}
          options={sortOptions}
        />
      </Flex>
    </Flex>
  );
}
